import { render, staticRenderFns } from "./CenterResponseQueue.vue?vue&type=template&id=6b560bba&scoped=true&"
import script from "./CenterResponseQueue.vue?vue&type=script&lang=js&"
export * from "./CenterResponseQueue.vue?vue&type=script&lang=js&"
import style0 from "./CenterResponseQueue.vue?vue&type=style&index=0&id=6b560bba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b560bba",
  null
  
)

export default component.exports